import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  useTheme,
  Button,
  Divider,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Table,
  TableCell,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import {
  ToggleBlueOn,
  ToggleBlueOff,
  AdminToggleActiveIcon,
  AdminToggleInActiveIcon,
} from "../../Svg";
import { headersGet, headersPost } from "../../Services/API";
import { ApiUrls } from "../../Services/Routes/API";
import { MainRoutes } from "../../Services/Routes/App";
import DelModal from "../Admin/DelModal";

const useStyles = makeStyles({
  headerText: {
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "30px",
    letterSpacing: "0.5px",
    color: "#252733",
  },
  bodyText: {
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "20px",
    color: "#828282",
  },
  mainBox: {
    padding: "8%",
    display: "flex",
    justifyContent: "space-between",
  },
  tableBodyText: {
    fontWeight: "400",
    textAlign: "center",
    fontSize: "13px",
    lineHeight: "20px",
    color: "#959595",
  },
});

const headings = ["Name", "Balance", "Status"];
const rows = [
  { name: "Jazzcash", balance: "N54321", status: true },
  { name: "Jazzcash", balance: "N54321", status: true },
  { name: "Jazzcash", balance: "N54321", status: true },
  { name: "Jazzcash", balance: "N54321", status: true },
  { name: "Jazzcash", balance: "N54321", status: true },
  { name: "Jazzcash", balance: "N54321", status: true },
];

const Setting = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const classes = useStyles();

  const [notification, setNotification] = useState(true);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [open, setOpen] = useState(false);
  const [freezeWallets, setFreezeWallets] = useState([]);
  const [product, setProduct] = useState([]);
  const [openFreezeModal, setOpenFreezeModal] = useState(false);
  const [api, setApi] = useState(false);

  const handleClosee = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  const getFreezeWalletsListing = () => {
    setOpen(true);
    headersGet(ApiUrls.GET_FREEZE_WALLETS)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setFreezeWallets(res?.data?.freeze_wallets);
          setOpen(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  const closeModalHandler = () => {
    setOpenFreezeModal(false);
  };
  const delProduct = (pro) => {
    setProduct(pro);
  };

  const walletFreezeHandller = () => {
    const data = {
      wallet: {
        id: product?.id,
        is_archived: !product?.is_archived,
      },
    };
    setOpen(true);

    headersPost(ApiUrls.FREEZE_WALLET, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setOpenFreezeModal(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setApi(!api);
        } else {
          setOpenFreezeModal(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getFreezeWalletsListing();
  }, [api]);

  return (
    <Box mt={7}>
      <Paper sx={{ borderRadius: 1 }}>
        <Box className={classes.mainBox}>
          <Box width={"60%"}>
            <Typography className={classes.headerText}>
              Notifications
            </Typography>
            <Typography className={classes.bodyText}>
              I want to receive e-mails about updates, transactions and
              withdrawals.{" "}
            </Typography>
          </Box>
          <Button
            variant="none"
            // onClick={() => {}}
            size="small"
            sx={{
              padding: theme.spacing(0),
              minWidth: "35px",
              borderRadius: 3,
            }}
          >
            {notification ? <ToggleBlueOn /> : <ToggleBlueOff />}
          </Button>
        </Box>
        <Box sx={{ paddingX: "10%" }}>
          {" "}
          <Divider />
        </Box>

        <Box className={classes.mainBox}>
          <Box width={"60%"}>
            <Typography className={classes.headerText}>E-mail</Typography>
            <Typography className={classes.bodyText}>
              I want to receive e-mails about updates, transactions and
              withdrawals.{" "}
            </Typography>
          </Box>
          <Button
            variant="none"
            // onClick={() => {}}
            size="small"
            sx={{
              padding: theme.spacing(0),
              minWidth: "35px",
              borderRadius: 3,
            }}
          >
            {notification ? <ToggleBlueOn /> : <ToggleBlueOff />}
          </Button>
        </Box>
        <Box sx={{ paddingX: "10%" }}>
          {" "}
          <Divider />
        </Box>
        <Box className={classes.mainBox}>
          <Box width={"60%"}>
            <Typography className={classes.headerText}>
              Two - factor authentication
            </Typography>
            <Typography className={classes.bodyText}>
              Two-factor authentication adds an extra layer of security to your
              account. To log in, in addition you'll need to provide a 6 digit
              code.
            </Typography>
          </Box>
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
          >
            <Button
              variant="contained"
              // onClick={() => {}}
              size="small"
              sx={{
                borderRadius: 1,
                height: 40,
                minWidth: 120,
              }}
            >
              Enable
            </Button>
          </Box>
        </Box>
      </Paper>
      <Paper sx={{ borderRadius: 1, marginTop: 2 }}>
        <Box paddingX={"8%"} paddingY={"5%"}>
          <Typography className={classes.headerText}>
            {" "}
            Freezed Wallets
          </Typography>
          <TableContainer>
            <Table
              sx={{ minWidth: 650, height: "200px" }}
              aria-label="simple table"
              stickyHeader
            >
              <TableHead>
                {" "}
                <TableRow>
                  {headings?.map((h, index) => {
                    {
                      return (
                        <TableCell
                          sx={{ fontWeight: "bold", textAlign: "center" }}
                          key={`${index}-table-heading-${h}`}
                        >
                          {h}
                        </TableCell>
                      );
                    }
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {freezeWallets?.map((row, index) => (
                  <TableRow key={`${index}-row.name-${index + 2}`}>
                    <TableCell className={classes.tableBodyText}>
                      {row?.name}{" "}
                    </TableCell>
                    <TableCell className={classes.tableBodyText}>
                      {row?.balance}
                    </TableCell>
                    <TableCell className={classes.tableBodyText}>
                      <Button
                        variant="none"
                        onClick={() => {
                          delProduct(row);
                          setOpenFreezeModal(true);
                        }}
                        size="small"
                        sx={{
                          padding: theme.spacing(0),
                          minWidth: "20px",
                          maxWidth: "35px",
                          maxHeight: "20px",
                          borderRadius: 3,
                        }}
                      >
                        {row?.is_archived ? (
                          <ToggleBlueOn />
                        ) : (
                          <ToggleBlueOff />
                        )}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>
      <DelModal
        header={"Status"}
        status={product?.is_archived}
        open={openFreezeModal}
        handleClose={closeModalHandler}
        statusHandler={walletFreezeHandller}
      />
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClosee}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClosee} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Setting;
